// extracted by mini-css-extract-plugin
export var borderRadius = "_8t-4";
export var large = "_8t-3";
export var logoContainer = "_8t-0";
export var nameLogo = "_8t-2";
export var small = "_8t-1";